// 餘額看板主頁面組件
export default {
  // 新手引導
  finishButton: "完成",

  // 搜索框
  searchPlaceholder: "請輸入你要搜索的案件",
  confirmButton: "確認",

  // 標題
  balanceDashboard: "餘額看板",
  updateData: "更新數據",

  // 加載和提示
  loading: "拼命加載中",
  tronUpdateInfo: "Tron鏈數據可手動更新，更新時間：",

  // 下拉選擇
  pleaseSelect: "請選擇",
  all: "全部",

  // 對話框
  tronUpdateSuccess: "Tron數據更新成功",
  updateSuccessMessage: "更新成功，確認後餘額看板數據將同步變化",
  closeButton: "關閉",
  confirmButtonDialog: "確認",

  // 錯誤信息
  noSearchResult: "你搜索的案件暫無結果！",
  noCaseData: "暫無案件數據，您可以通過畫布選擇地址加入到案件數據分析",
};
